import { type SdkConfig, SDKContext } from '@/sdk/contexts/SDKContext';
import ErrorBoundary from '@/sdk/pages/ErrorBoundary';
import Root from '@/sdk/Root';
import { PageLoading } from '@propify-tenant-client/common';
import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';

const App = lazy(() => import('./pages/app'));
const Unit = lazy(() => import('./pages/unit'));

const router = createHashRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '/',
        element: (
          <Suspense fallback={<PageLoading />}>
            <App />
          </Suspense>
        ),
        ErrorBoundary,
      },
      {
        path: '/units/:id',
        element: (
          <Suspense fallback={<PageLoading />}>
            <Unit />
          </Suspense>
        ),
        ErrorBoundary,
      },
    ],
    ErrorBoundary,
  },
]);

type Props = {
  config: Partial<SdkConfig>;
};

const Router: FC<Props> = ({ config }) => {
  return (
    <SDKContext.Provider
      value={{
        config,
      }}
    >
      <RouterProvider router={router} />
    </SDKContext.Provider>
  );
};

export default Router;
